
import { Player } from '@lottiefiles/react-lottie-player';
import { useState } from 'react';
import styled from 'styled-components';
import loading from './animation.json';

function Congratulation() {
  const [done, setDone] = useState(false);
  if (done) return null;
  return (
    <Container>
      <Player
        autoplay={true}
        src={loading}
        style={{ height: '100%', width: '100vw' }}
        speed={1}
        onEvent={(Events) => {
          if (Events === 'complete') {
            setDone(true);
          }
        }}
      ></Player>
    </Container>
  );
}

export default Congratulation;

const Container = styled.div`
position: fixed;
top: 0;
display: flex;
justify-content: center;
.lf-player-container {
  display: flex;
  justify-content: center;
}
`;